export default "__VITE_ASSET__Be2KVDHO__"